import Headspace from 'headspace';

jQuery(document).ready(function($) {
    /* Custom JS
	   Feel free to break into separate files if individual functions grow to excessive sizes.
	   Gulp will concatenate and minify separate files automatically.
    */

    // Initialize the sticky header
    let header = document.getElementById('header');

    Headspace(header, {
        tolerance: 8, // default: 8
        showAtBottom: true,
    });

    let args = {
        interval: false,
    };

    $('.block-case-study-slider.carousel').carousel(args);
    $('.block-testimonial-slider.carousel').carousel(args);
    $('.block-image-slider.carousel').carousel(args);
    $('.block-content-slider.carousel').carousel(args);
    $('.scrolling-cards.carousel').carousel(args);

    $(document).on(
        'click',
        '.scrolling-cards.carousel .carousel-control-next',
        function() {
            $('.scrolling-cards.carousel').carousel('next');
        }
    );
    $(document).on(
        'click',
        '.scrolling-cards.carousel .carousel-control-prev',
        function() {
            $('.scrolling-cards.carousel').carousel('prev');
        }
    );

    // Create the side-scrolling card slider.
    $('.scrolling-cards.carousel').on('slide.bs.carousel', function(e) {
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 3;
        var totalItems = $(this).find('.carousel-item').length;

        if (idx >= totalItems - (itemsPerSlide - 1)) {
            var it = itemsPerSlide - (totalItems - idx);
            for (var i = 0; i < it; i++) {
                // append slides to end
                if (e.direction == 'left') {
                    $(this)
                        .find('.carousel-item')
                        .eq(i)
                        .appendTo($(this).find('.carousel-inner'));
                } else {
                    $(this)
                        .find('.carousel-item')
                        .eq(0)
                        .appendTo($(this).find('.carousel-inner'));
                }
            }
        }
    });

    $(document).on('click', '.block-content-slider .nav li', function() {
        $(this)
            .siblings()
            .removeClass('active');
        $(this).addClass('active');
    });
});



// WEBPACK FOOTER //
// ./src/js/scripts.js